// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"275f2d444a0296ca","2927":"084122fbe22fda52","4417":"cfa7d0f32fda0c38","8974":"8a77b8c67ea667ec","9777":"3c4d53913293ac9a"}[chunkId] + ".js";
};